export default {
  "b2b.rezervace.widget.title.nejblizsi": "Next Reservation",
  "b2b.rezervace.widget.title-action.download": "Full Timetable"
};
